import Replypost from '../ replypost';
import SubCardSwitcher from '../subCardSwitcher';

export const postTypeConvert: Record<
  string,
  (post: ICardData, subtype: string, homeCards?: boolean) => JSX.Element
> = {
  market_post: (post, subtype, homeCards) => {
    return (
      <>
        <SubCardSwitcher post={post} subtype={subtype} homeCards={homeCards} />
      </>
    );
  },
  post: post => {
    return (
      <Replypost
        created={post.created_at}
        img={post?.image ? post?.image : null}
        title={post.title ? post.title : ''}
      />
    );
  },
  wanted: post => {
    return (
      <Replypost
        created={post.created_at}
        img={post?.image ? post?.image : null}
        title={post.title ? post.title : ''}
      />
    );
  },
  market_wanted: (post, subtype) => {
    return (
      <>
        <SubCardSwitcher post={post} subtype={subtype} />
      </>
    );
  },
};
